export default __webpack_public_path__ + "static/media/sagui.2f3bc1c1.svg";